.<template>
  <section class="error-page-section" :style="{backgroundImage: `url(${errorPage.bgImage})`}">
    <img class="error-page-central-img" v-if="errorPage.centerImage" :src="errorPage.centerImage" alt="">
    <div class="error-page-message-container" v-if="!errorPage.centerImage">
      <span>404</span>
      <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Veniam doloremque accusantium nulla magnam deleniti nemo vitae officiis perferendis similique ducimus a, quae perspiciatis assumenda! Adipisci.</p>
    </div>
    <a class='error-page-login-link' @click="goLogin">tentar login</a>
  </section>
</template>

<script>
export default {
  name: 'Error',
  data() {
    return {
      errorPage: { centerImage: '' },
    };
  },
  beforeMount() {
    this.errorPage = this.$store.state.template.errorPage;
  },
  methods: {
    goLogin() {
      this.$router.push({ name: 'Login' });
    },
  },
};
</script>

<style lang="scss">
.error-page-section {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  background-size: cover;
}
.error-page-message-container {
  background: white;
  color: black;
  font-size: clamp(100px, 12vw, 200px);
  max-width: 50%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  padding: 30px;
  @include media('<=phone-plus') {
    max-width: 90%;
  }
  p {
    font-size: 20px;
    opacity: 0.7;
  }
}
.error-page-central-img {
  width: clamp(280px, 60%, 800px);
  height: auto;
  object-fit: contain;
}
.error-page-login-link {
  cursor: pointer;
  font-size: 30px;
  color: white;
  background: #404040;
  padding: 20px;
  margin-top: 30px;
  user-select: none;
}
</style>